import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { deleteDossier, Dossier } from "../../../services/stixify_api.ts";
import LoadingButton from "../../../components/loading_button/index.tsx";
import { URLS } from "../../../services/urls.ts";

export const ConfirmDeleteDialog = ({ teamId, dossier, open, onClose }: {
    teamId: string, dossier: Dossier, onClose: () => void, open: boolean,
}) => {
    const [name, setName] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const deleteTeam = async () => {
        setLoading(true)
        try {
            await deleteDossier(teamId, dossier.id)
            navigate(URLS.teamDossiers(teamId))
        } catch (err) {

        }
        setLoading(false)
    }

    useEffect(() => {
        console.log(8888)
        setName('')
    }, [open])

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle><Typography variant="h5" sx={{ textAlign: 'center' }}>Confirm Delete Dossier</Typography></DialogTitle>
            <DialogContent>
                <Typography>
                    Deleting this dossier is irreversible.
                     Enter the dossier name: <code>{dossier.name}</code> to confirm
                </Typography>
                <Box sx={{ display: 'flex' }}>
                    <TextField
                        label='Team Name'
                        style={{ flex: 'auto', marginTop: '2rem' }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    ></TextField>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={() => onClose()} color="primary">
                    Close
                </Button>
                <LoadingButton isLoading={loading} disabled={name !== dossier.name} variant="contained" onClick={() => deleteTeam()} color="error">
                    Delete
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
